import React from 'react'

function ExpandSmMinusIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 2.5C0 1.11929 1.11929 0 2.5 0H7.5C8.88071 0 10 1.11929 10 2.5V7.5C10 8.88071 8.88071 10 7.5 10H2.5C1.11929 10 0 8.88071 0 7.5V2.5ZM2.5 1C1.67157 1 1 1.67157 1 2.5V7.5C1 8.32843 1.67157 9 2.5 9H7.5C8.32843 9 9 8.32843 9 7.5V2.5C9 1.67157 8.32843 1 7.5 1H2.5Z" fill="black"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.30768 5.00009C2.30768 4.78768 2.54876 4.61548 2.84614 4.61548H7.15383C7.45122 4.61548 7.69229 4.78768 7.69229 5.00009C7.69229 5.21251 7.45122 5.38471 7.15383 5.38471H2.84614C2.54876 5.38471 2.30768 5.21251 2.30768 5.00009Z" fill="black"/>
</svg>
  )
}

export default ExpandSmMinusIcon